













































import "./add-priority.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "AddPriority",
  components: { UserAvatar },
  props: {
    team: Object,
    show: Boolean,
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      userResult: [],
      sending: false,
      hashTagFilter: "All",
      selectedGoalIds: [],
      selectedProjectIds: [],
      selectedReviewIds: [],
      priorityModel: {
        type: "goal",
      },
      rules: {
        role: [
          {
            required: true,
            message: "Please choose a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles"]),
    ...mapState("goal", ["myTrackingGoals"]),
    ...mapState("review", ["myTrackingReviews"]),
    ...mapGetters("goal", ["currentGoalInviteRoles"]),
    ...mapState("project", ["myProjects"]),
    ...mapGetters("project", ["currentProjectInviteRoles"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    goalOptions(): any {
      let allGoals = this.$store.state.goal.myTrackingGoals || [];
      allGoals = allGoals.filter(
        (goal) =>
          (this.hashTagFilter === "All" || (goal.hashTagList && goal.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0)) &&
          !(!this.team.joinedGoals || this.team.joinedGoals.filter((joinedGoal) => joinedGoal.goalId == goal.id).length > 0)
      );
      return allGoals;
    },
    projectOptions(): any {
      let allProjects = this.$store.state.project.myProjects || [];
      allProjects = allProjects.filter(
        (project) =>
          (this.hashTagFilter === "All" || (project.hashTagList && project.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0)) &&
          !(!this.team.joinedProjects || this.team.joinedProjects.filter((joinedProject) => joinedProject.projectId == project.id).length > 0)
      );

      return allProjects;
    },
    reviewOptions(): any {
      let allReviews = this.$store.state.review.myTrackingReviews || [];
      allReviews = allReviews.filter(
        (review) =>
          (this.hashTagFilter === "All" || (review.hashTagList && review.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0)) &&
          !(!this.team.joinedReviews || this.team.joinedReviews.filter((joinedReview) => joinedReview.reviewId == review.id).length > 0)
      );

      return allReviews;
    },
    hashTagOptions() {
      let hashTags = ["All"];
      if (this.priorityModel.type === "goal") {
        let allGoals = this.$store.state.goal.myTrackingGoals || [];
        allGoals.forEach((goal) => {
          hashTags = hashTags.concat(goal.hashTagList.map((tag) => tag.text));
        });
      } else {
        let allProjects = this.$store.state.project.myProjects || [];
        allProjects.forEach((project) => {
          hashTags = hashTags.concat(project.hashTagList.map((tag) => tag.text));
        });
      }
      return [...new Set(hashTags)];
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.selectedGoalIds = [];
        this.selectedProjectIds = [];
        this.selectedReviewIds = [];
      }
    },
  },
  created() {
    this.$store.dispatch("goal/getMyTrackingGoals").then(() => {});
    this.$store.dispatch("project/getMyProjects", {}).then(() => {});
    this.$store.dispatch("review/getMyTrackingReviews").then(() => {});
  },
  methods: {
    handleAddPriority() {
      let context = this as any;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      (context.$refs["AddPriorityForm"] as any).validate((valid) => {
        if (valid) {
          let action = "";
          let data = {};
          if (context.priorityModel.type === "goal") {
            action = "goal/upsertTeam";
            data = {
              teamId: context.team.id,
              goalIds: context.selectedGoalIds,
            };
          } else if (context.priorityModel.type === "project") {
            action = "project/upsertTeam";
            data = {
              teamId: context.team.id,
              projectIds: context.selectedProjectIds,
            };
          } else if (context.priorityModel.type === "review") {
            action = "review/upsertTeam";
            data = {
              teamId: context.team.id,
              reviewIds: context.selectedReviewIds,
            };
          }

          this.$store
            .dispatch(action, {
              data: data,
            })
            .then((response) => {
              context.selectedGoalIds = [];
              context.selectedProjectIds = [];
              context.selectedReviewIds = [];

              context.$emit("reload-priorities");
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          context.sending = false;
          target.disabled = false;
          return;
        }
      });
    },
  },
});
